import CompanyDetailsTab from 'src/components/pages/Company/CompanyPage/CompanyDetailsTab/CompanyDetailsTab';

export default CompanyDetailsTab;
